
export enum RequestStatus {
    NOT_PERFORMED = 'NOT_PERFORMED',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
  }